import React from 'react';
import './table.css';

const RightTable = ({ title, icon, billingAmount, headers, data }) => {
  console.log('billingAmount', billingAmount)
  return (
    <div className="p-4 rounded-lg flex-1 summary-table relative" style={{ backgroundColor: '#F2F2F2', border: '1px solid #B0E3D9'}}>
      <div className="flex flex-col pl-[30px]">
        <span className="text-2xl mr-2 absolute top-4 left-1">{icon}</span>
        <h3 className="text-lg font-semibold" style={{fontSize: '16px'}}>{title}</h3>
        {billingAmount !== undefined ? <h3 className="text-lg font-semibold" style={{fontSize: '16px'}}>Billing Amount - {billingAmount}</h3> : <h3 className="text-lg font-semibold invisible" style={{fontSize: '16px'}}>Billing Amount - 0</h3>}
      </div>
      <table className="w-full text-center border-collapse">
        <thead>
          <tr className="border-none">
            {headers.map((header, index) => (
              <th key={index} className="p-2 border-none"><span style={{border: '2px solid #000', padding: '2px 4px', borderRadius: '4px'}}>{header}</span></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'border-none' : 'border-none'} style={{ height: '50px' }}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} className="p-2 border-none">{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RightTable;